// extracted by mini-css-extract-plugin
export var calendarView = "_ol-0";